import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {PaymentReceipt} from '@gatewee/types/payment';
import {resolveCompeDisplayName, UtilsModule} from '@gatewee/utils';
import {GateweeAmountFeeBreakdownComponent} from '../gatewee-amount-fee-breakdown/gatewee-amount-fee-breakdown.component';
import {GateweeCollapsibleDirective} from '../gatewee-collapsible/gatewee-collapsible.directive';
import {GateweeExpandChevronComponent} from '../gatewee-expand-chevron/gatewee-expand-chevron.component';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';

@Component({
  selector: 'gatewee-payment-receipt',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    UtilsModule,
    GateweeIconComponent,
    GateweeExpandChevronComponent,
    GateweeCollapsibleDirective,
    GateweeAmountFeeBreakdownComponent,
  ],
  templateUrl: './gatewee-payment-receipt.component.html',
  styleUrls: [
    '../styles/gatewee-collapsible-details.css',
    './gatewee-payment-receipt.component.css',
  ],
})
export class GateweePaymentReceiptComponent {
  @Input() receipt: PaymentReceipt | null | undefined;
  @Input() amount: number | null | undefined;
  @Input() calculatedFee: number | null | undefined;
  @Input() finalAmount: number | null | undefined;

  get showAmountBreakdown(): boolean {
    return (
      this.finalAmount !== null &&
      this.finalAmount !== undefined &&
      this.amount !== null &&
      this.amount !== undefined
    );
  }

  get receiverBankDisplayLine(): string {
    const recv = this.receipt?.receiver;
    if (!recv) {
      return '';
    }
    return resolveCompeDisplayName(recv.compeCode, recv.ispbCode).trim();
  }
}
